export default {
  props: {
    forOffice: {
      type: [Number, String],
      default() {
        return null;
      },
    },
    dateRange: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    fetchData() {
      throw new Error('Fetch data method not implemented');
    },
    calcPercentage(val, total) {
      return `${total > 0 ? Math.round((val / total) * 100) : 0}%`;
    },
  },
  watch: {
    dateRange() {
      this.fetchData();
    },
    forOffice() {
      this.fetchData();
    },
  },
};
